<h2 mat-dialog-title>Alert Items</h2>

<mat-dialog-content>

  <table mat-table [dataSource]="dataSource" class="w-100">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Item</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="count">
      <th mat-header-cell *matHeaderCellDef>Count</th>
      <td mat-cell *matCellDef="let row">{{ row.count }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
